package com.vidaensupalabra.vsp.ventanas

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import kotlinx.browser.window
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

import com.vidaensupalabra.vsp.ui.theme.VspBase
import com.vidaensupalabra.vsp.ui.theme.VspMarcoTransparente50
import com.vidaensupalabra.vsp.ui.theme.White
import com.vidaensupalabra.vsp.utils.*

private const val WHATSAPP_GROUP_URL = "https://chat.whatsapp.com/TU_ENLACE_AQUI" // TODO: Reemplaza con tu link real

@Composable
fun MasScreen(
    onNavigateToDonaciones: () -> Unit,
    onNavigateToMultimedia: () -> Unit,
    onNavigateToComunidad: () -> Unit,
    onNavigateToPerfil: () -> Unit
) {
    var feedbackMessage by remember { mutableStateOf("") }
    val coroutineScope = rememberCoroutineScope()

    val showFeedback: (String, Long) -> Unit = { msg, duration ->
        coroutineScope.launch {
            feedbackMessage = msg
            delay(duration)
            feedbackMessage = ""
        }
    }

    // Contenedor principal
    Div(attrs = {
        style {
            width(100.percent)
            minHeight(100.vh)
            backgroundColor(VspBase)
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            alignItems(AlignItems.Center)
            fontFamily("sans-serif")
            position(Position.Relative)
        }
    }) {
        MasTopAppBar()

        Div(attrs = {
            style {
                width(100.percent)
                maxWidth(800.px)
                padding(16.px)
                boxSizing("border-box")
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                gap(16.px)
            }
        }) {
            MenuActionButton("Agregar a Pantalla de Inicio", "📱") {
                val isStandalone = window.asDynamic().isStandalone() as Boolean
                if (isStandalone) {
                    showFeedback("La aplicación ya está instalada.", 3000)
                } else {
                    installPwa()
                    showFeedback("Revisa las opciones de instalación en pantalla.", 3500)
                }
            }
            
            MenuActionButton("Activar Notificaciones", "🔔") {
                when (getNotificationPermissionStatus()) {
                    "granted" -> showFeedback("Las notificaciones ya están activadas.", 3000)
                    "denied" -> showFeedback("Las notificaciones están bloqueadas. Revise los ajustes de su navegador.", 3500)
                    else -> solicitarPermisoNotificaciones()
                }
            }
            
            MenuActionButton("Buscar Actualización", "🔄") {
                reloadApp()
            }
            
            MenuActionButton("Mi Cuenta", "👤") {
                onNavigateToPerfil()
            }

            MenuActionButton("Comunidad", "👥") {
                onNavigateToComunidad()
            }

            MenuActionButton("Donaciones", "💖") {
                onNavigateToDonaciones()
            }
            
            MenuActionButton("Multimedia", "🎬") {
                onNavigateToMultimedia()
            }
            
            MenuActionButton("Grupo de WhatsApp", "💬") {
                window.open(WHATSAPP_GROUP_URL, "_blank")
            }

            MenuActionButton("Sitio Web Oficial", "🌐") {
                window.open("https://vidaensupalabra.com/", "_blank")
            }
            
            Div(attrs = { style { height(16.px) } })
            
            AppVersionCard()
            
            Div(attrs = { style { height(64.px) } }) // Margen inferior extra
        }

        FeedbackToast(message = feedbackMessage)
    }
}

@Composable
private fun MasTopAppBar() {
    Header(attrs = {
        style {
            width(100.percent)
            height(90.px)
            display(DisplayStyle.Flex)
            justifyContent(JustifyContent.Center)
            alignItems(AlignItems.Center)
        }
    }) {
        H2(attrs = {
            style {
                color(White)
                margin(0.px)
                fontSize(24.px)
                fontWeight("bold")
            }
        }) {
            Text("Vendrán Más Cosas")
        }
    }
}

@Composable
private fun MenuActionButton(title: String, icon: String? = null, onClick: () -> Unit) {
    Button(attrs = {
        onClick { onClick() }
        style {
            width(100.percent)
            padding(16.px)
            backgroundColor(VspMarcoTransparente50)
            border(0.px)
            borderRadius(8.px)
            cursor("pointer")
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Start)
        }
    }) {
        if (icon != null) {
            Span(attrs = {
                style {
                    fontSize(24.px)
                    marginRight(16.px)
                }
            }) { Text(icon) }
        }
        Span(attrs = {
            style {
                color(White)
                fontSize(18.px)
                fontWeight("bold")
            }
        }) { Text(title) }
    }
}

@Composable
private fun AppVersionCard() {
    Div(attrs = {
        style {
            width(100.percent)
            padding(24.px)
            backgroundColor(VspMarcoTransparente50)
            borderRadius(8.px)
            boxSizing("border-box")
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            alignItems(AlignItems.Center)
        }
    }) {
        Span(attrs = { style { color(White); fontSize(18.px); fontWeight("bold"); marginBottom(8.px) } }) {
            Text("Iglesia Vida en Su Palabra")
        }
        Span(attrs = { style { color(White); fontSize(16.px); marginBottom(12.px) } }) {
            Text("Versión de la App: 2.0.0 (PWA)")
        }
        Span(attrs = { style { color(Color("lightgray")); fontSize(12.px) } }) {
            Text("Desarrollado por Mario Alcala Lara")
        }
    }
}

@Composable
private fun FeedbackToast(message: String) {
    Div(attrs = {
        style {
            position(Position.Fixed)
            bottom(100.px) // Subimos un poco más para evitar colisión visual
            left(50.percent)
            property("transform", "translateX(-50%)")
            backgroundColor(rgba(0, 0, 0, 0.8)) 
            color(White)
            padding(12.px, 24.px)
            borderRadius(8.px)
            fontSize(16.px)
            property("z-index", 2000) // Aseguramos que se superponga al BottomNavigationBar (que tiene 1000)
            property("transition", "opacity 0.3s ease, transform 0.3s ease")
            opacity(if (message.isNotEmpty()) 1 else 0)
            property("pointer-events", if (message.isNotEmpty()) "auto" else "none")
        }
    }) {
        Text(message)
    }
}